import Masonry from 'masonry-layout';
import {fabric} from 'fabric/dist/fabric';
import Panzoom from '@panzoom/panzoom/dist/panzoom';
import Swiper from 'swiper/bundle';
import 'jquery-ui/ui/widgets/draggable';

export default {
  init() {
    // JavaScript to be fired on the about us page
  },
  finalize() {

    /**
     * Masonry Downloads
     * @click
     */
    if( $('.masonry-downloads').length ) {

      /**
       *
       */
      $( '.masonry-downloads' ).each(function(index) {

        var $elem = 'masonry-downloads-' + index;

        $(this).addClass($elem);

        var $masonry = '.' + $elem;

        /**
         * Grid
         */
        var $grid = {};

        $grid[index] = new Masonry($masonry, {
          percentPosition   :   true,
          itemSelector      :   '.masonry-downloads-item',
          gutter            :   0,
          transitionDuration:   0,
          columnWidth       :   '.grid-sizer',
        });

        /**
         * Load and Resize
         */
        $(window).on('load resize', function () {
          $grid[index].reloadItems();
          $grid[index].layout();
        });

        /**
         * Accordion
         * @click
         */
        $(document).on('click', $masonry + ' .accordion-downloads-title', function(e){

          const $li         = $(this).parent(),
            $html       = $li.find('.accordion-downloads-body'),
            program_ID  = $(this).data('program'),
            catalog_ID  = $(this).data('catalog'),
            course_ID   = $(this).data('course');

          if( $li.hasClass('active') ) {

            $($masonry + ' .accordion-downloads').find('.active').removeClass('active');

          }else{

            $($masonry + ' .accordion-downloads').find('.active').removeClass('active');
            $li.addClass('active');

            if( !$html.html().length ) {

              $.ajax( {
                beforeSend  :   function(){
                  $li.block({message : '', overlayCSS : {background : '#fff', opacity : 0.6}});
                },
                data        :   {
                  action      :   'courses',
                  catalog_id  :   catalog_ID,
                  program_id  :   program_ID,
                  course_id   :   course_ID,
                },
                dataType    :   'json',
                method      :   'POST',
                complete    :   function(){
                  $li.unblock();
                },
                success     :   function( data ){

                  $html.html(data.data.html);

                  $grid[index].reloadItems();
                  $grid[index].layout();

                },
                url         :   window.nec.ajax_url,
              } );

            }

          }

          /**
           * Masonry reinit
           */
          if (typeof $grid[index] !== 'undefined') {
            $grid[index].reloadItems();
            $grid[index].layout();
          }

          /**
           *
           */
          e.preventDefault();

        });

      });

    }

    /**
     * Accordion
     * @click
     */
    if( $('.accordion').length ) {

      $(document).on('click', '.accordion-title', function(e){

        const $li = $(this).parent();

        if( $li.hasClass('active') ) {

          $('.accordion').find('.active').removeClass('active');

        }else{

          $('.accordion').find('.active').removeClass('active');
          $li.addClass('active');

        }

        e.preventDefault();

      });

    }

    /**
     * Play Button
     */
    if($('.newssingle__content .wp-block-video').length) {

      /**
       * Insert Button
       */
      $( '.newssingle__content .wp-block-video' ).each(function() {

        $(this).append($('<a href="#play" class="btn-video-play"></a>'));

      });

      /**
       * Click Button Play
       */
      $(document).on('click', '.btn-video-play', function(){

        const video = $(this).parent().find('video');

        if(video.get(0).paused){

          video.get(0).play();
          $(this).fadeOut();

        }else{

          video.get(0).pause();
          $(this).fadeIn();

        }

      });

    }


    /**
     * TourMap
     * @type {{init: init}}
     */
    let TourMapSingle = function () {

      /**
       * Global
       * @type {number}
       */
      let CONFIG = {
        marker_default_color  : '#CB333B',
        point_default_color   : '#00226B',
      },
        // eslint-disable-next-line no-unused-vars
        TOOLTIP_VISIBLE   = 0,
        TOOLTIP_TIMER     = null,
        TOOLTIP_TIMER_2   = null,
        CLICKED_MARKER    = 0,
        ACTIVE_OBJECT     = 0,
        canvas            = new fabric.Canvas('tour-canvas', {
          hoverCursor             : 'pointer',
          preserveObjectStacking  : false,
          enableRetinaScaling     : false,
          imageSmoothingEnabled   : false,
        });

      /**
       * Install
       * @param data
       * @constructor
       */
      let Install = function () {

        /**
         * Global
         * @type {number}
         */

        let map_json = $('.map_tour__inner').data('json');

        canvas.loadFromJSON(map_json, function() {

          canvas.renderAll();
          canvas.forEachObject(function(object){

            object.selectable = false;

              /**
               * Click
               */
              object.on('mousedown', function(e) {

                //e.target._objects[0];

                if( e.target ) {

                  $('.map_tour__tooltip').removeClass('active');

                  if( e.target.element_type === 'marker' ) {

                    SetObjectHoverStyle(e);

                    CLICKED_MARKER = 1;
                    ACTIVE_OBJECT = e.target.id;
                    LoadDetail(e);


                  }
                }

              });

              /**
               * Over Object
               */
              object.on('mouseover', function(e) {

                if( e.target ) {

                  SetObjectHoverStyle(e);

                  if( CLICKED_MARKER === 0 ) Tooltip(e, 'over')

                }

              });

              /**
               * Out Object
               */
              object.on('mouseout', function(e) {

                if( e.target ) {

                  if( CLICKED_MARKER === 0 ) Tooltip(e, 'out')

                }

              });

          });

        }, function(){

          let window_w = $(window).width() / 2,
              window_h = $(window).height() / 2,
              canvas_w = (canvas.width / 2) - window_w,
              canvas_h = (canvas.height / 2) - window_h;

          $('.canvas-container').css({
            left  : -canvas_w,
            top   : -canvas_h,
          });

        });

        fabric.Object.prototype.transparentCorners = false;
        canvas.selection = false;

        const element = document.querySelectorAll('.canvas-container'),
              zoomInButton = document.getElementById('map_tour_zoomIn'),
              zoomOutButton = document.getElementById('map_tour_zoomOut');

        let panzoom;

        for (var i = 0; i < element.length; i++) {

          panzoom = Panzoom(element[i], {
            animate     : true,
            duration    : 600,
            maxScale    : 1.9,
            minScale    : 0.5,
            step        : 0.1,
            canvas      : false,
            //contain     : 'outside',
            disablePan  : false,
            exclude: ['circle', 'group'],
            // eslint-disable-next-line no-unused-vars
            handleStartEvent: function (e) {
              // e.preventDefault();
              // e.stopPropagation();
            },
          });

          element[i].addEventListener('panzoomchange', (event) => {
            if( event.detail.scale === 1 ) {
              console.dir('panzoom disable');
              panzoom.destroy();
            }
          });

        }

        zoomInButton.addEventListener('click', panzoom.zoomIn);
        zoomOutButton.addEventListener('click', panzoom.zoomOut);

        //panzoom.destroy()


        /**
         * Open Detail Tour
         * @tourOpenDetail
         */
        $(document).on('click', '.tourOpenDetail', function() {

          const $this   = $(this),
                post    = $this.data('id'),
                left    = $this.data('left'),
                right   = $this.data('right'),
                id_element = $this.data('element');

          CLICKED_MARKER = 1;

          ACTIVE_OBJECT = id_element;
          LoadDetail({ target: { left: left, right: right } }, post, id_element);

        });

        /**
         * Expand Post Full Width
         * @tourTextExpand
         */
        $(document).on('click', '.tourTextExpand', function(e){

          e.preventDefault();

          $('.map_detail').toggleClass('full');
          $('.header_tour__breadcrumbs').toggleClass('hide');

        });

        /**
         * Close Right Panel
         * @tourClosePanel
         */
        $(document).on('click', '.tourClosePanel', function(e){

          e.preventDefault();

          $('.map_tour').removeClass('tour__read');
          $('.map_detail').removeClass('full');
          $('.canvas-container').find('.map_tour__tooltip').removeClass('active');

          $('.tourNextItem, .tourPrevItem').show()

          /**
           * Show Objects
           * @HideObjects
           */
          CLICKED_MARKER = 0;
          HideObjects(null, 'show');

        });

        /**
         * Next Post
         * @tourNextItem
         */
        $(document).on('click', '.tourNextItem', function(e){

          e.preventDefault();

          Navigations('next');

        });

        /**
         * Prev Post
         * @tourPrevItem
         */
        $(document).on('click', '.tourPrevItem', function(e){

          e.preventDefault();

          Navigations('prev');

        });

      }

      /**
       *
       * @param e
       * @param type
       * @constructor
       */
      let Tooltip = function (e, type) {

        let $canvas_container = $('.canvas-container'),
            $tooltip          = $('.map_tour__tooltip');

        if( !$canvas_container.find('.map_tour__tooltip').length ) {
          $canvas_container.append($tooltip.clone());
        }

        $tooltip = $('.canvas-container').find('.map_tour__tooltip');

        if( 'out' === type ) {

          clearTimeout(TOOLTIP_TIMER_2);
          TOOLTIP_TIMER = setTimeout( function () {

              $tooltip.removeClass('active');
              clearTimeout(TOOLTIP_TIMER_2);
              TOOLTIP_VISIBLE = 0;
              ResetObjects();

          }, 500);

        }else{

          clearTimeout(TOOLTIP_TIMER_2);
          clearTimeout(TOOLTIP_TIMER);
          TOOLTIP_VISIBLE = 1;

          /**
           *
           */
          $tooltip.html('');

          let marker_link = '';
          if( e.target.element_type == 'marker' ) {
            marker_link = '<a href="#modal-right" class="link tourOpenDetail" data-id="' + e.target.element_tour_id + '" data-left="' + e.target.left + '" data-right="' + e.target.right + '" data-element="' + e.target.id + '">Learn More</a>';
          }

          $tooltip.append(
            '<div class="map_tour__tooltip__marker">' +
            '<h3 class="title">' +
            e.target.element_tooltip +
            '</h3>' +
            marker_link +
            '</div>'
          ).ready(function () {

            // eslint-disable-next-line no-unused-vars
            var h_tooltip = $tooltip.outerHeight(true),
                w_tooltip = $tooltip.outerWidth(true),
                h_element = e.target.height,
                w_element = e.target.width;

            $tooltip.css({
              left: ((e.target.left - ( w_tooltip / 2 )) + ( w_element / 2 )) - 8,
              top: ((e.target.top - h_tooltip) - ( h_element / 2 )) + 8,
            });

            $tooltip.addClass('active');

          });


          $tooltip.mouseenter(function() {

            $tooltip.addClass('active');
            TOOLTIP_VISIBLE = 1;
            clearTimeout(TOOLTIP_TIMER);
            clearTimeout(TOOLTIP_TIMER_2);

          }).mouseleave(function() {

            TOOLTIP_TIMER_2 = setTimeout( function () {

                TOOLTIP_VISIBLE = 0;
                $tooltip.removeClass('active');
                clearTimeout(TOOLTIP_TIMER);
                ResetObjects();


            }, 500);

            clearTimeout(TOOLTIP_TIMER);

          });

        }

      }

      /**
       *
       * @param e
       * @param type
       * @constructor
       */
      let LoadDetail = function (e, post = 0, element = 0, navigation = false) {

        /**
         *
     */
        if( element > 0 ) {
          canvas.forEachObject(function(object){
            if( object.id === element ) e = { target: object };
          });
        }

        /**
         * Center Map
         * @type {number}
         */
        let window_w = $(window).width() / 2,
            window_h = $(window).height() / 2,
            canvas_w = e.target.left - ( window_w / 2 ),
            canvas_h = e.target.top - window_h;

        $('.canvas-container').stop().animate({
          left: -canvas_w,
          top: -canvas_h,
        });

        if( post === 0 ) {
          post = e.target.element_tour_id;
        }

        /**
         * Hide Objects
         * @HideObjects
         */

        HideObjects(e, 'hide');

        /**
         *
         */
        if( true === navigation ) e.target.opacity = 1;


        /**
         * Ajax
         */

        $.ajax( {

            beforeSend  :   function(){

              $('.tourDetailAjax').html('');
              $('.map_tour').addClass('tour__read');
              $('.map_detail__content').addClass('preloader');

            },
            data        :   {
              action    :   'tour_get_item',
              post      :   post,
            },
            dataType    :   'json',
            method      :   'POST',
            complete    :   function(){ },
            // eslint-disable-next-line no-unused-vars
            success     :   function( response ){

              $('.map_detail__content').removeClass('preloader');
              $('.tourDetailAjax').html(response.data.html).ready(function(){

                if( $('.wp-swiper').length ) {

                  // eslint-disable-next-line no-unused-vars
                  const swiper = new Swiper('.wp-swiper .swiper-container', {
                    speed         : 400,
                    autoHeight: true, //enable auto height

                    spaceBetween    : 0,
        effect          :'fade',
        pagination      : {
          el            : '.swiper-pagination',
          clickable     : true,
          type          : 'bullets',
        },
        navigation: {
          nextEl        : '.swiper-button-next',
          prevEl        : '.swiper-button-prev',
        },
      });
    }

              });

            },
            // eslint-disable-next-line no-undef
            url         :   nec.ajax_url,
          } );

      }

    /**
       *
       * @param e
       * @param type
       * @constructor
     */
      let DragMap = function () {

        $('.canvas-container').draggable({
          drag : function(event,ui){
            var parent = ui.helper[0].parentNode;

            var dragWidth = ui.helper[0].clientWidth;
            var parentWidth = parent.clientWidth;
            var dragHeight = ui.helper[0].clientHeight;
            var parentHeight = parent.clientHeight;

            var widthDifference = dragWidth - parentWidth;
            var heightDifference = dragHeight - parentHeight;

            if(ui.position.left > 0) ui.position.left = 0;
            else if(ui.position.left < -widthDifference) ui.position.left = -widthDifference;

            if(ui.position.top > 0) ui.position.top = 0;
            else if(ui.position.top < -heightDifference) ui.position.top = -heightDifference;

        },
        });

        // let drag = false;
        //
        // $('.canvas-container').on('mousedown touchstart', function(){
        //   drag = true;
        // }).on('mouseup mouseout', function(){
        //   $(this).data({
        //     startX: 0,
        //     startY: 0,
        //   });
        //   drag = false;
        // }).on('mousemove touchmove', function(e){
        //   e.preventDefault();
        //   if(drag){
        //     //console.log($(this).data(),e);
        //     var left = parseInt($(this).css('left')) || 0,
        //       top = parseInt($(this).css('top')) || 0,
        //       newLeft = left + (e.clientX - ($(this).data().startX || e.clientX)),
        //       newTop  = top + (e.clientY - ($(this).data().startY || e.clientY)),
        //       parentHeight = $(this).parent().height(),
        //       parentWidth = $(this).parent().width(),
        //       imgHeight = $(this).height(),
        //       imgWidth = $(this).width();
        //
        //     $(this).css({
        //       left: newLeft < 0 && (Math.abs(newLeft - parentWidth) < imgWidth) ? newLeft : left,
        //       top: newTop < 0 && (Math.abs(newTop - parentHeight) < imgHeight) ? newTop : top,
        //     }).data({
        //       startX: e.clientX,
        //       startY: e.clientY,
        //     });
        //
        //   }
        // });

      }

      /**
       *
       * @constructor
       */
      let HideObjects = function (e, type) {

        if( 'show' === type ) ResetObjects()

        // eslint-disable-next-line no-unused-vars
        canvas.forEachObject(function(object){

          if( 'hide' === type ) {

            // eslint-disable-next-line no-unused-vars
            const element_click = e.target.id;

            if( element_click != object.id ) {

              object.opacity = 0;

            }else{

              SetObjectHoverStyle({ target: object})

            }

            canvas.renderAll();

          }


        })

      }

      /**
       *
       * @param e
       * @constructor
       */
      let SetObjectHoverStyle = function (e) {

        e.target._objects[0].set('opacity', 1);
        e.target._objects[0].set('fill', 'black');
        e.target._objects[0].set('strokeWidth', 6);
        e.target._objects[0].set('stroke', 'rgba(0,0,0,0.3)');
        canvas.renderAll();

      }

      /**
       *
       * @constructor
       */
      let ResetObjects = function () {

        if( CLICKED_MARKER == 0 ) {
          canvas.forEachObject(function (object) {

            if (object.element_type === 'marker') {
              object._objects[0].set('fill', CONFIG.marker_default_color);
            } else if (object.element_type === 'point') {
              object._objects[0].set('fill', CONFIG.point_default_color);
            }
            object._objects[0].set('strokeWidth', 2);
            object._objects[0].set('stroke', 'white');
            object.opacity = 1;

          })
          canvas.renderAll();
        }

      }

      /**
       *
       * @constructor
       */
      let Navigations = function (type) {

        let $next_button = $('.tourNextItem'),
            $prev_button = $('.tourPrevItem')
        /**
         *
         */
        let obj = [];
        canvas.getObjects().forEach(function(o) {

          if( o.element_type == 'marker' ) {
            obj.push(o);
          }

        })

        // eslint-disable-next-line no-unused-vars
        let it = 0,
          // eslint-disable-next-line no-unused-vars
          bty = [];

        // eslint-disable-next-line no-unused-vars
        $.each(obj, function( index, value ) {

          if( value.id === ACTIVE_OBJECT ) {

            if( 'next' === type ) bty = obj[index + 1];
            if( 'prev' === type ) bty = obj[index - 1];

          }

      });

        let last_item_arr = [];
        if( undefined == bty ) {

          if( 'next' === type ) $next_button.hide();
          if( 'prev' === type ) $prev_button.hide();

        }else{

          if (Object.keys(bty).length > 0) {

            ACTIVE_OBJECT = bty.id

            LoadDetail({target: bty}, bty.element_tour_id, bty.id, true);
            SetObjectHoverStyle({target: bty})

            /**
             * Last Item Array
             * @type {*}
             */
            last_item_arr = obj.slice(-1).pop();

          }

          if( 'next' === type ) {
            $prev_button.show()
            if( last_item_arr.id === bty.id ) {
              $next_button.hide()
            }
          }

          if( 'prev' === type ) {
            $next_button.show()
            if( obj[0].id === bty.id ) {
              $prev_button.hide()
    }
          }

        }

      }

      /**
       * @return
       */
      return {
        init: function () {
          Install();
          DragMap();
        },
      };
    }();

    /**
     * Init TourMap
     */
    if( $('#tour-canvas').length ) {
      TourMapSingle.init();
    }






  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js